module.exports = __webpack_public_path__ + "img/clint8.8d1cfd18.png";